"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_persist_1 = require("redux-persist");
/**
 * `redux-persist` transformer that reset the persisted redux state after a specific period of time.
 * @param {number} expireIn For how long the state is going to be preserved
 * @param {string} [expireKey="persistencyExpiration"] Key used by the localStorage
 * @param {any} defaultValue Value to which state will be cleared to
 */
var transformExpire = function (expireIn, expireKey, defaultValue) {
    if (expireKey === void 0) { expireKey = "persistencyExpiration"; }
    if (defaultValue === void 0) { defaultValue = {}; }
    var storedExpiration = localStorage.getItem(expireKey);
    var expired = false;
    if (storedExpiration) {
        var expiring = parseInt(storedExpiration);
        var now = new Date().getTime();
        expired = !isNaN(expiring) && now > expiring;
    }
    return redux_persist_1.createTransform(function (inboundState) {
        setTimeout(function () {
            var expireValue = (new Date().getTime() + expireIn).toString();
            localStorage.setItem(expireKey, expireValue);
        }, 0);
        return inboundState;
    }, function (outboundState) {
        return expired ? defaultValue : outboundState;
    });
};
exports.default = transformExpire;
//# sourceMappingURL=index.js.map